export const BACKGROUND_BLUE = '#00c2ff';
export const BACKGROUND_YELLOW = '#fcb622';
export const BACKGROUND_VIOLET = '#493afc';

export const BACKGROUND_OPTIONS = [BACKGROUND_BLUE, BACKGROUND_YELLOW, BACKGROUND_VIOLET];